export const formName = 'maximale hypotheek';
export const type = 'form';
